import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const NotificacionesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const [datosTabla] = useState({
    titulo: "Notificaciones",
    ruta: "/notificacion",
    esAgregar: true,
    esEditar: false,
    esEliminar: false,
    //eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_AN" },
    { title: "TITULO", key: "TITULO_AN" },
    { title: "SUBTITULO", key: "SUBTITULO_AN" },
    { title: "FECHA ALTA", key: "FECHA_ALTA_AN", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_notificaciones",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default NotificacionesPage;